import React from 'react';
import { useDrag } from 'react-dnd';
import styles from './AvailableEmployees.css';

export const DraggableType = 'employee';

const makeStyle = ({ color }) => !color ? null : {
  border: '1px solid #ccc', 
  padding: '2px 8px', 
  borderRadius: '5px', 
  fontWeight:'bold',
};
const employeeList = ({color}) => !color ? {
  border: '1px solid #ccc', 
  padding: '2px 8px', 
  borderRadius: '5px', 
  fontWeight:'bold',

} :{
  border: '1px solid #ccc', 
  padding: '2px 8px', 
  borderRadius: '5px', 
  fontWeight:'bold',
  backgroundColor: color,
};

const employeeCheck = ({employeeCheck}) => !employeeCheck ? null : {
  display: 'block',
}

const Employee = ({ employee, color, updateSelectedEmployeeList,employeeCheck }) => {

 
 
  
  const [, drag] = useDrag({
    item: { employeeId: employee.id, employee, type: DraggableType },
  });
  return (
    <div
      ref={drag}      
    >
     
     <p className={styles.employeeList}  style={{ position:'relative',
        backgroundColor: color ? `${color}` : '', color: color ? '#fff' : '',
      }}>{ employee.firstName }  { employee.lastName } 
    <span className={styles.employeeCheck} style={{display:employeeCheck ? 'none' : 'block'}}><input name = {employee.id} value={employee.id} type="checkbox" onChange={(e) => updateSelectedEmployeeList({  selected: e.target.checked,
    empid: e.target.value })}></input> </span>
    </p>
    </div>
  );
};

export default Employee;
